module.exports = __webpack_public_path__ + "static/media/webApps_smallToBig.d954c031.md";